<template>
 <section class="qj-footer">
   <div class="footer">
     <div class="footer-top">
       <el-row>
         <el-col :sm="15" :xs="15"><a href="tel:400-618-3958 " class="f-phone"><svg-icon icon-class="phone"></svg-icon>400-618-3958</a></el-col>
         <el-col :sm="9" :xs="9"><a href="/aboutUs#myform" class="f-leave"> <svg-icon icon-class="leave"></svg-icon>在线预约</a></el-col>
       </el-row>
     </div>
     <el-row>
       <el-col class="m-none" :xs="24" :sm="6">
         <div class="footer-item">
          <div class="footer-title">关于弘范智汇</div>
           <div class="footer-cate">

             <div class="f-item"><a href="/aboutUs#jianjie">企业简介</a></div>
             <div class="f-item"><a href="/aboutUs#jianjie">愿景及使命</a></div>
             <div class="f-item"><a href="/aboutUs#lianxi">联系我们</a></div>
           </div>
         </div>
       </el-col>
       <el-col class="m-none" :xs="24" :sm="6">
         <div class="footer-item">
           <div class="footer-title">服务支持</div>
           <div class="footer-cate">
             <div class="f-item"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740"  target="_blank">预约课程</a></div>
             <div class="f-item"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740"  target="_blank">在线咨询</a></div>
           </div>
         </div>
       </el-col>
       <el-col class="m-none" :xs="24" :sm="6">
        <div class="footer-item">
          <div class="footer-title">合作交流</div>
          <div class="footer-cate">

            <div class="f-item"><a href="/px/organizationDetails/6">行业组织合作</a></div>
            <div class="f-item"><a href="/studyAbroad">国外游学</a></div>
          </div>
        </div>
       </el-col>


       <el-col :xs="24" :sm="5">
        <div class="footer-item">
          <div class="footer-title">业务入口</div>
          <div class="footer-cate">

            <div class="f-item"><a href="/attractInvestment">招商合作</a></div>
            <div class="f-item"><a href="javascript:;">清洁学院</a></div>
            <div class="f-item"><a href="javascript:;">洁满仓商城</a></div>
          </div>
        </div>
       </el-col>



       <el-col :xs="24" :sm="1" class="social-box">
         <ul class="social">
<!--           <li><a href="javasrcpt:void(0);" class="weixin qjico_wechat">
               <div class="hied_wx_code">
                 <div class="wx_wrap">
                   <div class="hd"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/qingjiegongsi/images2/qcode.png" width="150" height="150"></div>
                   <div class="bd">
                     <p class="p01">手机扫码关注我们</p>
                     <p class="p02">请使用微信扫一扫</p>
                   </div>
                 </div>
               </div>
             </a>
           </li> -->
           <li><a href="javascript:;" class="weixin qjico_phone" target="_blank">
               <div class="hied_wx_code hied_phone_code">
                 <div class="wx_wrap">
                   <div class="bd">
                     <p class="p01 bold">400-618-3958</p>
                   </div>
                 </div>
               </div>
             </a></li>
           <li><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740" target="_blank" class="zhihu qjico_consult"></a></li>

         </ul>
       </el-col>

     </el-row>



     <div class="footer-item">
       <div class="footer-title">免费课程</div>
       <el-row>
         <el-col :sm="6" :xs="8" v-for="index of 10 " :key="index">
           <div class="f-item"><a :href="'/freeCourses/'+index">{{freeCourseList[index].title}}</a></div>
         </el-col>
       </el-row>
     </div>
       <div class="footer-item">
       <div class="footer-title">付费课程</div>
       <el-row>
         <el-col :sm="6" :xs="12" v-for="item in courseList" :key="item.id">
           <div class="f-item"><a  :href="'/paidCourses/'+item.id">{{item.title}}</a></div>
         </el-col>
       </el-row>
     </div>
     <div class="footer-item">
       <div class="footer-title">培训教材</div>
       <el-row>
         <el-col :sm="6" :xs="12">


           <div class="f-item"><a href="/teachingMaterial/12">清洁服务技术（基础知识）</a></div>
         </el-col>
         <el-col :sm="6" :xs="12">


           <div class="f-item"><a href="/teachingMaterial/13">清洁服务技术（初级）</a></div>
         </el-col>
         <el-col :sm="6" :xs="12">


           <div class="f-item"><a href="/teachingMaterial/14">清洁服务技术（中级）</a></div>
         </el-col>

         <el-col :sm="4" :xs="12">

           <div class="f-item"><a href="/teachingMaterial/15">清洁服务技术（高级）</a></div>
         </el-col>

       </el-row>
     </div>
   </div>
   <div class="copy">
     <div class="copy-info">
     <el-row class="pcopy">
      <el-col :sm="15" :xs="24">
         <div class="copy-i-left"><a href="http://beian.miit.gov.cn" target="_blank">京ICP备19056920号</a>&nbsp;&nbsp;@2019&nbsp;&nbsp;北京弘范智汇管理顾问有限公司&nbsp;&nbsp;&nbsp;&nbsp;版权所有</div>
      </el-col>
       <el-col :sm="9" :xs="24">
          <div class="copy-i-right">
           <a href="/px/other/34">法律声明</a>
           </div>
      </el-col>
     </el-row>
     <el-row class="mcopy">
      <el-col :sm="15" :xs="24">
         <div class="copy-i-left">Copyright © 2019 北京弘范智汇管理顾问有限公司</div>
      </el-col>
      <el-col :sm="15" :xs="24">
         <div class="copy-i-left"><a href="http://beian.miit.gov.cn" target="_blank">京ICP备19056920号</a></div>
      </el-col>
       <el-col :sm="9" :xs="24">
          <div class="copy-i-left">
           <a href="/px/other/34">法律声明</a>
           </div>
      </el-col>
     </el-row>
     </div>
   </div>
   <div class="extension-bottom">
      <el-row>
        <el-col :xs="8"><a href="tel:4006183958"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/qingjiegongsi/phone/extension/dibu-icon01.gif"></a></el-col>
        <el-col :xs="8"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/qingjiegongsi/phone/extension/dibu-icon02.gif"></a></el-col>
        <el-col :xs="8"><a href="/attractInvestment"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/qingjiegongsi/phone/extension/dibu-icon04.gif"></a></el-col>
      </el-row>
    </div>
 </section>
</template>

<script>
  import Vue from 'vue'
  import VideoPlayer from 'vue-video-player';
  import 'vue-video-player/src/custom-theme.css';
  import 'video.js/dist/video-js.css';

  import freeCourseList from '../../assets/json/video.json';

  Vue.use(VideoPlayer);
  export default {
    data() {
      return {
        current: 0,
        path: domain.apiUrl,
        freeCourse : {},
        freeCourseList:freeCourseList,
        courseList:[],
        bookList:[]
      };
    },
    created(){
      this.getCourse();

    },
    methods:{

      getCourse:function () {
        this.$http.get(this.path + '/course/list?type=1').then((response) => {
          if (response.status === 200) {
            this.courseList = response.body;
          }
        }, (response) => {
          this.$message.error("error")
        });
      }
    }
  };
</script>

<style lang="scss">
   @import "../../assets/css/footer.scss"
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue